export const SAVE = 'collisionDamageStep.SAVE';
export const VALUE_CHANGED = 'collisionDamageStep.VALUE_CHANGED';
export const LOAD = 'collisionDamageStep.VALUE_LOAD';
export const NEXT = 'collisionDamageStep.NEXT';
export const RESET = 'collisionDamageStep.RESET';
export const RESET_DAMAGED_LOST_EXPENSE = 'collisionDamageStep.RESET_DAMAGED_LOST_EXPENSE';
export const RESET_DELAYED_LUGGAGE_EXPENSE = 'collisionDamageStep.RESET_DELAYED_LUGGAGE_EXPENSE';
export const RESET_COMPENSATION = 'collisionDamageStep.RESET_COMPENSATION';
//-------------------------------------------------------
export const RESET_TRIP_CANCELLATION_STATE = 'collisionDamageStep.RESET_TRIP_CANCELLATION_STATE';
export const RESET_TRAVEL_INTERRUPTION_STATE = 'collisionDamageStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_TRAVEL_DELAY_STATE = 'collisionDamageStep.RESET_TRAVEL_DELAY_STATE';
//------------------------------------------------------
export const RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE = 'collisionDamageStep.RESET_FOR_DAMAGE_LOST_OR_STOLEN_LUGGAGE_STATE';
export const RESET_FOR_BAGGAGE_DELAY_STATE = 'collisionDamageStep.RESET_TRAVEL_INTERRUPTION_STATE';
export const RESET_EUROPEAN_UNION_STATE = 'collisionDamageStep.RESET_EUROPEAN_UNION_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.CollisionDamageStep/constants.js